import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import FileUploader from './FileUploader';
import LinkedInSuggestions from './LinkedInSuggestions';

const UploadCvLinkedin = ({isActive , setIsActive ,linkedinProfiles , setLinkedinProfiles})  => {
   
    const [isShow , setIsShow] = useState(true);

    
  return (
      
           <div className="rounded-lg bg-[#4285F4]/10 border border-[#4285F4]/50 p-3">
             <div
               className=" relative flex items-center justify-start gap-2 cursor-pointer "
               onClick={(e) => setIsActive(!isActive)}
             >
               <div className="flex flex-1 items-center justify-start gap-2">
                 <img
                   src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/requestCv.png?updatedAt=1750520500587"
                   alt=""
                   className="h-[28px] w-[28px]"
                   width={28}
                   height={28}
                 />
                 <div className="flex flex-col items-start justify-center gap-2 leading-tight">
                   <div className="text-[16px] md:text-[18px] font-medium text-white">
                     Upload CV & LinkedIn
                   </div>
                   <div className="text-[12px] md:text-[14px] text-white/50">
                     Share your CV & LinkedIn to get noticed
                   </div>
                 </div>
               </div>
               <FontAwesomeIcon
                 icon={isActive ? faChevronDown : faChevronRight}
                 size="md"
                 className="absolute right-0 text-white "
               />
             </div>
              {
                isActive && <div className='mt-4'>
                  <FileUploader/>
                  <div className="mt-2">
                    <LinkedInSuggestions linkedinProfiles={linkedinProfiles} setLinkedinProfiles={setLinkedinProfiles}/>
                  </div>
                </div>
              }
           </div>
        
  )
}

export default UploadCvLinkedin
